import { useState, useEffect } from 'react';
import WelcomeModal from './WelcomeModal';
import { csrfToken } from '~/utils/csrf';

interface OnboardingStatus {
  show_welcome: boolean;
  username: string;
  stamps: number;
}

export default function OnboardingProvider() {
  const [status, setStatus] = useState<OnboardingStatus | null>(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Check onboarding status on mount
    const checkOnboardingStatus = async () => {
      try {
        const response = await fetch('/api/v1/onboarding/status', {
          credentials: 'include',
        });

        if (response.ok) {
          const data = await response.json();
          setStatus(data);
          if (data.show_welcome) {
            setShowModal(true);
          }
        }
      } catch (error) {
        // Silently fail - user might not be logged in
        console.debug('Onboarding check failed:', error);
      }
    };

    checkOnboardingStatus();
  }, []);

  const handleClose = async () => {
    setShowModal(false);

    // Mark onboarding as complete
    try {
      await fetch('/api/v1/onboarding/complete', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken(),
        },
      });
    } catch (error) {
      console.error('Failed to complete onboarding:', error);
    }
  };

  if (!showModal || !status) {
    return null;
  }

  return (
    <WelcomeModal
      username={status.username}
      stamps={status.stamps}
      onClose={handleClose}
    />
  );
}
